// extracted by mini-css-extract-plugin
export default {"daten-container":"datenschutz_daten-container__w5CBH","daten":"datenschutz_daten__h-I2e"};